/**
 * Ordre d'affichage des pages du site (onglets + menu viewer).
 * `pageOrder` est optionnel dans web_data : rétrocompatibilité avec `Object.keys(pages)`.
 */
export function getPageOrder(webData) {
  const pages = webData?.pages || {};
  const keys = Object.keys(pages);
  const stored = Array.isArray(webData?.pageOrder)
    ? webData.pageOrder.filter((s) => pages[s] != null)
    : [];
  const missing = keys.filter((k) => !stored.includes(k));
  return stored.length ? [...stored, ...missing] : keys;
}

export function arrayMove(arr, fromIndex, toIndex) {
  if (fromIndex === toIndex || fromIndex < 0 || toIndex < 0) return [...arr];
  const copy = [...arr];
  const [item] = copy.splice(fromIndex, 1);
  copy.splice(toIndex, 0, item);
  return copy;
}

/**
 * Réordonne en déplaçant `fromSlug` pour qu'il se retrouve *avant* l'index `insertBeforeIndex`
 * (0 = tout au début, length = tout à la fin).
 */
export function reorderPagesAtInsertPoint(order, fromSlug, insertBeforeIndex) {
  const fromIdx = order.indexOf(fromSlug);
  if (fromIdx === -1) return [...order];
  const next = [...order];
  next.splice(fromIdx, 1);
  let idx = insertBeforeIndex;
  if (fromIdx < insertBeforeIndex) idx -= 1;
  idx = Math.max(0, Math.min(idx, next.length));
  next.splice(idx, 0, fromSlug);
  return next;
}

/**
 * Ordre des onglets après régénération : d’abord les pages statiques du parse (template),
 * puis les statiques conservées qui ne sont pas dans ce parse (ex. pages utilisateur),
 * puis les pages proposal. Évite que des statiques absentes de `pageOrder` se retrouvent
 * en fin de liste via le fallback de `getPageOrder`.
 *
 * @param {{ pages?: object, pageOrder?: string[] }} parseWebData - sortie brute de parseProposalToWebData
 * @param {string[]} preservedStaticSlugsInOrder - slugs statiques à réinjecter (ordre souhaité parmi eux)
 */
export function mergeRegeneratedPageOrder(parseWebData, preservedStaticSlugsInOrder = []) {
  const parsePages = parseWebData?.pages || {};
  const parseOrder = Array.isArray(parseWebData?.pageOrder) ? parseWebData.pageOrder : [];
  const parseStatic = parseOrder.filter((s) => parsePages[s]?.type === 'static');
  const proposal = parseOrder.filter((s) => parsePages[s]?.type !== 'static');
  const parseStaticSet = new Set(parseStatic);
  const preservedExtra = preservedStaticSlugsInOrder.filter((s) => !parseStaticSet.has(s));
  return [...parseStatic, ...preservedExtra, ...proposal];
}
